import { stacks } from '../entities/stacks-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask, ITaskType, registerTask } from './jobs'
import { jobs } from './jobs-sidecar'
import { createTask_moveTo } from './taskMoveTo'
import { createTask_placeInEmptySpace } from './taskPlaceInEmptySpace'
import { createTask_stackCargo } from './taskStackCargo'
import { createTask_deliverCargo } from './taskDeliverCargo'

const type: ITaskType = 'put-away'
export const register = () => registerTask(type, runTask)

export function createTask_putAway(i: number, j: number): ITask {
  return jobs._createTask(i, j, type, {})
}

function runTask(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, type)
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  if (!m.carryingCargo) {
    jobLogger.succeedTask(job, task)
    return
  }

  // Search for a valid stack
  let stack = stacks.findClosestStackForStorage(
    m.i,
    m.j,
    m.carryingCargo.data.type,
    null,
  )
  if (stack) {
    task.subtasks.push(
      createTask_deliverCargo(
        stack.i,
        stack.j,
        m.carryingCargo.data.type,
        true,
      ),
    )

    task.subtasks.push(
      createTask_stackCargo(stack.i, stack.j, m.carryingCargo.data.type),
    )
  } else {
    // Just put this anywhere
    task.subtasks.push(createTask_placeInEmptySpace(m.i, m.j))
  }
}
